(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const swiperContainer = document.querySelector('[data-collection-carousel-new]');
        if (!swiperContainer) return;
        
        const swiper = new Swiper(swiperContainer, {
            slidesPerView: 3.333,
            spaceBetween: 10,
            centeredSlides: false,
            centerInsufficientSlides: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                enabled: false
            },
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 15,
                    navigation: {
                        enabled: true
                    }
                },
                1600: {
                    slidesPerView: 6,
                    navigation: {
                        enabled: true
                    }
                }
            },
            on: {
                init: function() {
                    updateNavClass(this);
                },
                resize: function() {
                    updateNavClass(this);
                }
            }
        });

        function updateNavClass(swiperInstance) {

            let effectiveSlidesPerView = swiperInstance.params.slidesPerView;
    
            if (effectiveSlidesPerView === 'auto') {
                effectiveSlidesPerView = swiperInstance.slides.length;
            }
            
            if (swiperInstance.slides.length > effectiveSlidesPerView) {
                swiperContainer.classList.add('has-navigation');
            } else {
                swiperContainer.classList.remove('has-navigation');
            }
        }
    });

  } catch(e) { console.error(e); }
})();
})();
